import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useDeleteRemoverPropaganda() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const deleteRemoverPropaganda = useCallback(
        (propagandaId: string) =>
            invocarApi({
                url: `/v2/Propagandas/${propagandaId}`,
                method: 'DELETE',
                baseURL: VariaveisAmbiente.apiPropaganda + '/api',
                enviarTokenUsuario: true,
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        deleteRemoverPropaganda,
    };
}
